import "../../styles/Achievements.css";

function Achievements() {
  return <main className="main">Achievements</main>;
}

export default Achievements;
